import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'nk-list-extra-info',
  imports: [RouterLink, TranslateModule],
  templateUrl: './list-extra-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListExtraInfoComponent {
  public routerLink = input<string | unknown[]>();
  public text = input<string>();
}
